import { render, staticRenderFns } from "./MaintanacePage.vue?vue&type=template&id=5931c01e&scoped=true"
import script from "./MaintanacePage.vue?vue&type=script&lang=js"
export * from "./MaintanacePage.vue?vue&type=script&lang=js"
import style0 from "./MaintanacePage.vue?vue&type=style&index=0&id=5931c01e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5931c01e",
  null
  
)

export default component.exports